import React, { Component } from 'react';
import { Meteor } from 'meteor/meteor';
import { get, isEqual, isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import * as layerOps from '../../../api/Layers/layer-operations';
import { styleFetchOne } from '../../../api/Styles/style-methods-client';

import { featurePoint2LatLng, featureGetZoom } from '../../../modules/geojson-utilities';
import getDefaultStyle from '../../../modules/get-default-style';

import LeafletMap from '../../components/LeafletMap';

let addOnlineBaseMap;
let getMapCenter;
let drawSingleLayer;
let addDefaultBaseMap;

const { defaultMapCenter } = Meteor.settings.public;

class MapContainerMapThumbnail extends Component {
  state = {
    isLeafletMapLoaded: get(this, 'layerThumbnailMapComponent.current.state.isMapLoaded', false),
    isLayerMapLoaded: false,
    clientModulesReady: false
  };

  layerThumbnailMapComponent = React.createRef();

  layerThumbnailMap = null;

  layerToDraw = null;

  componentDidMount() {
    const { clientModulesReady } = this.state;
    if (!clientModulesReady) {
      this.loadClientModules();
    }
  }

  async componentDidUpdate(prevProps) {
    const { isLeafletMapLoaded, isLayerMapLoaded, clientModulesReady } = this.state;
    const { layer, defaultBaseMap } = this.props;
    const { layer: prevLayer, defaultBaseMap: prevDefaultBaseMap } = prevProps;
    if (clientModulesReady && isLeafletMapLoaded && !isLayerMapLoaded) {
      this.initializeMap();
    }
    if (
      isLayerMapLoaded &&
      !isEmpty(defaultBaseMap) &&
      !isEqual(prevDefaultBaseMap, defaultBaseMap)
    ) {
      await addDefaultBaseMap({
        defaultBaseMap,
        leafletMap: this.layerMap,
        isUpdate: true
      });
    }
    if (isLayerMapLoaded && !isEqual(prevLayer, layer)) {
      const style = (await styleFetchOne(layerOps.getStyleId(layer))) || getDefaultStyle(layer);
      this.layerToDraw = await drawSingleLayer({
        layer,
        style,
        leafletMap: this.layerThumbnailMap,
        layerToDraw: this.layerToDraw,
        isUpdate: true,
        isThumbnailMap: true
      });
    }
  }

  updateMapState = newState => {
    this.setState({ isLeafletMapLoaded: newState });
  };

  initializeMap = async () => {
    const { layer, defaultBaseMap } = this.props;
    this.layerThumbnailMap = get(this, 'layerThumbnailMapComponent.current.leafletMap');
    let layerLocation = layerOps.getMapLocation(layer);
    if (isEmpty(layerLocation)) {
      layerLocation = defaultMapCenter;
    }
    this.layerThumbnailMap.setView(
      featurePoint2LatLng(getMapCenter({ location: layerLocation })),
      featureGetZoom(layerLocation)
    );
    if (isEmpty(defaultBaseMap)) {
      addOnlineBaseMap(this.layerThumbnailMap);
    } else {
      await addDefaultBaseMap({
        defaultBaseMap,
        leafletMap: this.layerThumbnailMap
      });
    }
    const style = (await styleFetchOne(layerOps.getStyleId(layer))) || getDefaultStyle(layer);
    this.layerToDraw = await drawSingleLayer({
      layer,
      style,
      leafletMap: this.layerThumbnailMap,
      layerToDraw: this.layerToDraw,
      isThumbnailMap: true
    });
    if (layerOps.isGeoJSONApiBased(layer)) {
      this.layerThumbnailMap.fitBounds(this.layerToDraw.getBounds());
    }
    this.setState({ isLayerMapLoaded: true });
  };

  async loadClientModules() {
    if (Meteor.isClient) {
      ({ addOnlineBaseMap, getMapCenter, drawSingleLayer, addDefaultBaseMap } = await import(
        '../../../modules/leaflet-operations'
      ));
      this.setState({ clientModulesReady: true });
    }
  }

  render() {
    const { layer, deployEnv } = this.props;
    return (
      <LeafletMap
        mapId={`layerThumbnailMap-${layerOps.getId(layer)}`}
        isThumbnailMap
        ref={this.layerThumbnailMapComponent}
        updateMapState={this.updateMapState}
        deployEnv={deployEnv}
      />
    );
  }
}

MapContainerMapThumbnail.propTypes = {
  layer: PropTypes.object.isRequired,
  deployEnv: PropTypes.string.isRequired,
  defaultBaseMap: PropTypes.object.isRequired
};

export default MapContainerMapThumbnail;
